<div id="containerNotFound">
    <div class="ContainerText">
        <div>
            <h1>404</h1>
            <h2>{{ "404.text" | translate }}</h2>
            <a [routerLink]="['/home']" class="btn-primary">
                {{ "404.homebutton" | translate }}
            </a>
        </div>
    </div>
    <div class="shadow"> </div>
    <div class="background">
        <img src="./assets/images/backgrounds/fond-included_8.jpg" alt="background-image">
    </div>
</div>
